// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1A3tM","empty":"ModalGraph_empty__3tcWN"};